var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupFormCustomInputDateV1 = {
    attach: function (context) {}
  };
})(jQuery);
